import * as React from "react";
import * as ReactDOM from "react-dom";
import { Icon, Button, Drawer, Transfer, message } from "antd";
import {
  PositionProperty,
  BorderTopProperty,
  TextAlignProperty
} from "csstype";

// 颜色表达
import { EColor } from "../../utils/enum/color";

// interface IFieldDrawer {
//   // 原始数据
//   data: any;
//   // 回调事件
//   onSubmit: any;
//   // 关联组件的名称
//   componentName?: any;
// }

interface IDrawerTransfer {
  visible: any;
  // 原始数据
  data: any;
  // 关联组件的名称
  componentName?: any;
  onClose: any;
  onSubmit: any;
  targetKeys: any;
}

// 设置字段显示/隐藏面板
class DrawerTransfer extends React.Component<IDrawerTransfer, any> {
  state = {
    code: "",
    visible: true,
    mockData: [],
    targetKeys: this.props.targetKeys,
    // 控制代码框显示隐藏的状态
    codeVisible: false,
    // 代码应用状态
    codeSettState: false,
    // 抽屉组件ref
    drawerRef: null
  };

  constructor(props: any) {
    super(props);
  }

  static newInstance = function newDrawerTransferInstance(
    properties: any,
    callback
  ) {
    const { ...props } = properties || {};
    const div = document.createElement("div");
    // if (getContainer) {
    //   const root = getContainer();
    //   root.appendChild(div);
    // } else {
    document.body.appendChild(div);
    //}
    let called = false;
    function ref(drawerTransfer) {
      if (called) {
        return;
      }
      called = true;
      callback({
        component: drawerTransfer,
        destroy: () => {
          setTimeout(() => {
            ReactDOM.unmountComponentAtNode(div);
            if (div.parentNode) div.parentNode.removeChild(div);
          }, 200);
        }
      });
    }
    ReactDOM.render(<DrawerTransfer {...props} ref={ref} />, div);
  };

  onClose = () => {
    this.setState({
      visible: false
    });
    this.props.onClose && this.props.onClose();

    // this.setState({
    //   visible: false
    // });
  };

  filterOption = (inputValue, option) => {
    return option.title.indexOf(inputValue) > -1;
  };

  handleChange = targetKeys => {
    this.setState({ targetKeys });
    this.initCode(targetKeys);
  };

  initTransfer = item => item.title;

  onSubmit = () => {
    this.setState({
      visible: false
    });
    this.props.onSubmit(this.state.targetKeys);
  };

  initCode = targetKeys => {
    let code = { name: this.props.componentName, fields: [] };
    code.fields = targetKeys || this.state.targetKeys;
    this.setState({
      code: JSON.stringify(code),
      codeSettState: false
    });
  };

  //   获取代码
  getCode = () => {
    this.initCode(null);

    // 更新代码框显示/隐藏状态
    this.setState({
      codeVisible: !this.state.codeVisible
    });
  };

  // 代码更新事件
  onCodeChange = e => {
    this.setState({
      code: e.target.value,
      codeSettState: false
    });
  };

  getByClass = sClass => {
    var aResult: any = [];
    var aEle = document.getElementsByTagName("*");

    for (var i = 0; i < aEle.length; i++) {
      if (aEle[i].className == sClass) {
        aResult.push(aEle[i]);
      }
    }

    return aResult;
  };

  // 应用代码 更新穿梭框中要隐藏字段部分的信息
  settCode = () => {
    let codeJson = JSON.parse(this.state.code);
    // 消息提示应用在抽屉组件上
    message.config({
      getContainer: () => {
        if (this.state.drawerRef) {
          const htmlElements = this.getByClass("ant-drawer-content-wrapper");
          return (
            (htmlElements && htmlElements.length && htmlElements[0]) ||
            document.body
          );
        }
        return document.body;
      }
    });

    message.success("设置成功");
    this.setState({
      targetKeys: codeJson.fields,
      codeSettState: true
    });
  };

  //   显示代码框
  showCode = () => {
    if (this.state.codeVisible) {
      const iconStyle = {
        fontSize: 40,
        cursor: "pointer",
        position: "absolute" as PositionProperty,
        bottom: 32,
        right: 32,
        color: !this.state.codeSettState ? EColor.underway : EColor.completed //"#1890ff"
      };
      return (
        <React.Fragment>
          <textarea
            value={this.state.code}
            style={{ width: "100%", height: "100%" }}
            onChange={this.onCodeChange}
          />
          <Icon
            type="setting"
            title="应用代码"
            style={iconStyle}
            onClick={this.settCode}
          />
        </React.Fragment>
      );
    }
    return [];
  };

  // initDrawer = ref => {
  //   this.setState({
  //     drawerRef: ref
  //   });
  // };

  render() {
    const style = {
      position: "absolute" as PositionProperty,
      color: "#1890ff",
      top: -16,
      right: 0,
      cursor: "pointer"
    };

    const drawerStyle = {
      position: "absolute" as PositionProperty,
      bottom: 0,
      width: "100%",
      borderTop: "1px solid #e8e8e8" as BorderTopProperty<3>,
      padding: "10px 16px",
      textAlign: "right" as TextAlignProperty,
      left: 0,
      background: "#fff",
      borderRadius: "0 0 4px 4px"
    };

    const cancleStyle = { marginRight: 8 };

    const listStyle = {
      height: 500
    };

    const codeStyle = {
      position: "relative" as PositionProperty,
      marginTop: 12,
      height: 300
    };

    return (
      <Drawer
        title="设置显示/隐藏的字段"
        placement="right"
        closable={true}
        width={540}
        onClose={this.onClose}
        visible={this.state.visible}
      // ref={this.initDrawer}
      >
        <Transfer
          dataSource={this.props.data}
          titles={["显示的字段", "隐藏的字段"]}
          showSearch
          filterOption={this.filterOption}
          targetKeys={this.state.targetKeys}
          onChange={this.handleChange}
          render={this.initTransfer}
          listStyle={listStyle}
          searchPlaceholder="请输入搜索内容"
          notFoundContent="列表为空"
        />
        <div style={codeStyle}>
          <Icon
            type={!this.state.codeVisible ? "codepen" : "codepen-circle"}
            title={!this.state.codeVisible ? "查看代码" : "关闭"}
            style={style}
            onClick={this.getCode}
          />
          {this.showCode()}
        </div>
        <div style={drawerStyle}>
          <Button style={cancleStyle} onClick={this.onClose}>
            取消
          </Button>
          <Button onClick={this.onSubmit} type="primary">
            确认
          </Button>
        </div>
      </Drawer>
    );
  }
}

export default DrawerTransfer;
